import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Aside = ({marketBlock}) => {
    const [activeCategory, setActiveCategory] = useState("home");
    const [systems, setSystems] = useState([]);
    const [sociallink, setSociallink] = useState([]);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [showBlockedModal, setShowBlockedModal] = useState(false);
    const [blockedSection, setBlockedSection] = useState('');
    const CloseTabBar = () => {
        const chatElement = document.querySelector('.cdk-overlay-container');
            chatElement.classList.add('d-none');
            const aside = document.querySelector('.aside');
            aside.classList.remove('active'); 
      };
    const handleCategoryClick = (type) => {
        setActiveCategory(type);
    };


    // Menu data
const menuData = [
    { title: "Home", icon: "icon-home.png", type: "home", link: "/" },
    { title: "Sports", icon: "icon-sport.png", type: "SPORTS" },
    { title: "Casino", icon: "icon-casino.png", type: "LIVE" },
    { title: "Slot", icon: "icon-slot.png", type: "SLOT" },
    { title: "Table", icon: "icon-table.png", type: "TABLE" },
    { title: "Poker", icon: "icon-arcade.png", type: "BINGO" },
    { title: "Crash", icon: "icon-crash.png", type: "EGAME" },
    { title: "Fishing", icon: "icon-fish.png", type: "FH" },
    { title: "Lottery", icon: "icon-lottery.png", type: "LOTTO" },
];

const promotionData = [
    { title: "Promotions", icon: "icon-promotion.png", link: "promotions" },
    { title: "Referral Program", icon: "icon-referral.png", link: "refrrel-program" },
    { title: "VIP", icon: "icon-vip.png", link: "/vip" },
];
const origin = window.location.origin
  .replace(/^https?:\/\/(www\.)?/, '');

const supportData = [
    { title: "Affiliate", icon: "icon-affiliate.png", link: `https://affilaite.${origin}/login` },
    { title: "24/7 LiveChat", icon: "icon-talk.png", description: "Provides 24/7 Quality service", onclick: "handleChatClick", },
    { title: "Brand Ambassador", icon: "icon-ambassador.png", description: "Play with celebrity", link: "/vip" },
];

const providerData = [{ platform: "icon-all-provider.svg" }];

const sportsOptions = [
    { name: "Exchange", icon: "icon-exchange.svg", link: "/exchange" },
    { name: "I-Sports", icon: "icon-sportbook.svg", link: "/gamerun" },
    { name: "E1Sports", icon: "icon-awcme1sport.svg", link: "/gamerun" },
    { name: "Horsebook", icon: "icon-horsebook.svg", link: "/gamerun" },
    { name: "Virtual", icon: "icon-virtual.svg", link: "/gamerun" },
    { name: "Kabaddi", icon: "icon-kabaddi.svg", link: "/gamerun" },
    { name: "Fantasy", icon: "icon-powerelevenv2.svg", link: "/gamerun" },
    { name: "SBO Sports", icon: "icon-sbov2.svg", link: "/gamerun" },
];


const [providers, setProviders] = useState(providerData);

    

    useEffect(() => {
        const selectedMenu = menuData.find(item => item.type === activeCategory);
        if (selectedMenu && activeCategory !== "home") {
            fetchSystems(selectedMenu.type);
        } else {
            setSystems([]);
            setProviders(providerData);
        }
    }, [activeCategory]);
    // new function to handle category click
    const handleCasinoClick = (system, type) => {
        const selectedMenu = menuData.find(item => item.type === type);
         if (marketBlock?.cs_market === 0 && marketBlock?.status !== 'active') {
        setBlockedSection('Games');
        setShowBlockedModal(true);
        return;
    } else if (selectedMenu) {
        const { title } = selectedMenu;
        navigate(`/games?type=${type}&system=${system}&title=${encodeURIComponent(title)}`);
        } else {
            console.error('Selected menu item not found');
        }
    };
    // new function to handle exchange click
    const handleExchangeClick = () => {
    if (marketBlock?.exchange_market === 0 && marketBlock?.status !== 'active') {
      setBlockedSection('Exchange');
      setShowBlockedModal(true);
      return;
    }
    navigate('/exchange');
  };
    

    const fetchSystems = async (type) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-system?type=${type}`);
            const data = await response.json();
            if (response.ok) {
                setSystems(data.systems || []);
                fetchProviders(data.systems);
            } else {
                setError(data.message || 'Failed to fetch systems');
            }
        } catch (error) {
            console.error('Error fetching systems:', error);
            setError('An unexpected error occurred while fetching systems');
        }
    };

    const fetchProviders = async (systems) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-provider?system=${JSON.stringify(systems)}`);
            const data = await response.json();
            if (response.ok) {
                setProviders([{ platform: "icon-all-provider.svg" }, ...(data.data || [])]);
                console.log('Providers fetched:', data.data);
            } else {
                setError(data.message || 'Failed to fetch providers');
            }
        } catch (error) {
            console.error('Error fetching providers:', error);
            setError('An unexpected error occurred while fetching providers');
        }
    };
    const [dragging, setDragging] = useState(false);
      const [logo, setLogo] = useState("");
      
      const [whatsappLink, setWhatsappLink] = useState(null);
      const [dragDistance, setDragDistance] = useState(0);
    
      const [position, setPosition] = useState({
        x: window.innerWidth - 70,
        y: window.innerHeight - 150,
      });
    
      const [offset, setOffset] = useState({ x: 0, y: 0 });
    
      // Fetch logo
      useEffect(() => {
        const fetchLogo = async () => {
          try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
            if (!response.ok) throw new Error("Failed to fetch logo");
            const data = await response.json();
            setLogo(`${process.env.REACT_APP_API_URL}/storage/${data[0].mobile_logo}`);
          } catch (error) {
            console.error("Error fetching logo:", error);
          }
        };
    
        fetchLogo();
      }, []);
      useEffect(() => {
        if (window.location.origin === "https://www.chat.com") {
          window.__lc = window.__lc || {};
          window.__lc.license = 19116631;
    
          (function (n, t, c) {
            function i(n) {
              return e._h ? e._h.apply(null, n) : e._q.push(n);
            }
            var e = {
              _q: [],
              _h: null,
              _v: "2.0",
              on: function () {
                i(["on", c.call(arguments)]);
              },
              once: function () {
                i(["once", c.call(arguments)]);
              },
              off: function () {
                i(["off", c.call(arguments)]);
              },
              get: function () {
                if (!e._h)
                  throw new Error("[LiveChatWidget] You can't use getters before load.");
                return i(["get", c.call(arguments)]);
              },
              call: function () {
                i(["call", c.call(arguments)]);
              },
              init: function () {
                var n = t.createElement("script");
                n.async = !0;
                n.type = "text/javascript";
                n.src = "https://cdn.livechatinc.com/tracking.js";
                t.head.appendChild(n);
              },
            };
            !n.__lc.asyncInit && e.init();
            n.LiveChatWidget = n.LiveChatWidget || e;
          })(window, document, [].slice);
        }
      }, []);
    
      
    
        const [show, setShow] = useState(null);
        useEffect(() => {
            let whatsapp = localStorage.getItem("whatsapp");
            let live_chat = localStorage.getItem("liveChat");
            // let intercom = localStorage.getItem("intercom");
            if (live_chat!=='null') {
                setShow('live_chat');
            }else {
                setShow('base_chat');
            }
            setWhatsappLink((whatsapp!=='null') ? whatsapp : null);
        }, [show]);
    
     
    
      
        
        // Listen for the custom event to open chat
        useEffect(() => {
            window.addEventListener('open_chat', function () {
                handleChatClick();
            });
        }, [show]);
    
        
        const handleChatClick = (e) => {
            console.log("Chat Clicked!");
            console.log(whatsappLink);
            if (e) {
                e.preventDefault();
            }
    
            const remoteId = localStorage.getItem("remote_id");
            const username = localStorage.getItem("username");
            
            if (window.Intercom) {
                window.Intercom("show");
            }else if (whatsappLink && whatsappLink.length > 0) {
                console.log("WhatsApp Link:", whatsappLink);
                window.open(whatsappLink, "_blank");
            } else {
                console.log('anw2');
                if (window.anw2) {
                    window.anw2.open();
                }
                if (window.LiveChatWidget) {
                    console.log('lch');
                    window.LiveChatWidget.once("ready", () => {
                        if (remoteId && username) {
                            window.LiveChatWidget.call("set_customer_data", {
                                name: username,
                                external_id: remoteId, 
                            });
                        }
                        window.LiveChatWidget.call("maximize");
                    });
                }
                if (window.Tawk_API) {
                    window.Tawk_API.maximize();
                }
            }
        };
      
      

    return (
        <div className="cdk-overlay-container d-none">
            <div className="cdk-overlay-backdrop dialog-backdrop cdk-overlay-backdrop-showing" />
            <div className="cdk-global-overlay-wrapper" style={{ justifyContent: "center", alignItems: "center" }}>
                <div className="cdk-overlay-pane dialog-panel">
                    <div className="popup">
                        <div className="popup__header"></div>
                        <div className="popup__content">
                            <div className="menu aside">
                                <div className="menu-first">
                                    {/* Main logo at the top of aside menu */}
                                    <div className="menu-logo">
                                        <img src={logo || "/logo.png"} alt="main-logo" />
                                    </div>
                                    <ul className="home">
                                        {menuData.map((item, index) => (
                                            <li key={index} className={activeCategory === item.type ? "active" : ""}>
                                                <span className="item-icon" style={{ backgroundImage: `url(https://img.j189eb.com/jb/h5/assets/images/icon-set/theme-icon/${item.icon})` }} />
                                                <a onClick={() => handleCategoryClick(item.type)} href={item.link || "#"}>
                                                    {item.title}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>

                                    <ul className="promotion-block">
                                        {promotionData.map((item, index) => (
                                            <li key={index}>
                                                <span className="item-icon" style={{ backgroundImage: `url(./icons/${item.icon})` }} />
                                                
                                                <Link to={item.link} >{item.title}</Link>
                                            </li>
                                        ))}
                                    </ul>

                                    <div className="support-block">
                                    {supportData.map((item, index) => (
                                                <Link 
                                                    key={index} 
                                                    to={item.link || "#"} 
                                                    onClick={item.onclick ? () => handleChatClick() : null} 
                                                >
                                                    <div className="service">
                                                        <span className="item-icon" style={{ backgroundImage: `url(./icons/${item.icon})` }} />
                                                        <p className='ng-star-inserted'>{item.title}</p>
                                                    </div>
                                                </Link>
                                            ))}
                                    </div>
                                </div>

                                {activeCategory !== "home" && (
                                    <div className="menu-second">
                                        {activeCategory === "SPORTS" && (
                                            <ul className="menu-second-ul active">
                                                {sportsOptions.map((sport, index) => (
                                                    <li key={index}>
                                                        {/* new function */}
                                                        <a onClick={sport.name === "Exchange" ? handleExchangeClick : () => navigate(sport.link)}>

                                                            <div className="icon-sport" style={{ maskImage: `url(./icons/${sport.icon})` }} />
                                                            <p>{sport.name}</p>
                                                       
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}

                                        {!["home", "SPORTS"].includes(activeCategory) && (
                                            <ul className="menu-second-ul active">
                                                {providers.map((provider, index) => (
                                                    <li key={index}>
                                                        <a onClick={() => provider.platform.endsWith('.svg')
                                                            ? handleCasinoClick(systems.join(','), activeCategory)
                                                            : handleCasinoClick(provider.platform, activeCategory)} href="#">
                                                            {provider.platform.endsWith('.svg') ? (
                                                                <img className="icon-provider" src={`./icons/${provider.platform}`} alt={provider.name} />
                                                            ) : (
                                                                <img
                                                                    className="icon-provider"
                                                                    src={`${process.env.REACT_APP_API_URL}/provider/${provider.platform}.png`}
                                                                    alt={provider.name || provider.platform}
                                                                    onError={(e) => { e.target.src = './icons/platform/' + provider.platform + '.png'; }}
                                                                />
                                                            )}
                                                            <p>{provider.platform.endsWith('.svg') ? 'ALL' : (provider.name || provider.platform)}</p>
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}

                                    </div>
                                )}
                            </div>
                            <div onClick={CloseTabBar} className="menu-mask" style={{ display: 'block' }}></div>
                        </div>
                    </div>
                </div>
            </div>
            {/* new function to handle blocked modal */}
            {showBlockedModal && (
            <div className="cdk-overlay-container">
                <div className="cdk-overlay-backdrop dialog-backdrop cdk-overlay-backdrop-showing" />
                <div className="cdk-global-overlay-wrapper" dir="ltr" style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <div id="cdk-overlay-2" className="cdk-overlay-pane dialog-panel" style={{ position: 'static' }}>
                    <div className="popup" id="dialog-2">
                        <div className="popup__header"></div>
                        <div className="popup__content">
                        <div className="pop-wrap promotion-pop new ng-trigger ng-trigger-popWrapTriggerAni ani show ">
                            <a className="btn-close" onClick={() => setShowBlockedModal(false)}>
                            <span className="item-icon" style={{ backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-cross-type01.svg?v=1743412106882")' }} />
                            </a>

                            <div className="pop-title">
                            <h3>【Market Block】</h3>
                            </div>
                            <div className="pop-inner content-style">
                            <div>
                                <p>
                                Dear customer,<br />
                                Your selected section "{blockedSection}" is currently blocked by Your Upline.
                                </p>
                                <p>Please Contact Customer Support for further assistance.</p>
                                <p>Thank you for your understanding.</p>
                            </div>
                            </div>
                        </div>

                        <div className="pop-bg" style={{ display: 'block' }} />
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        )}
        </div>
    );
};

export default Aside;
